export default __webpack_public_path__ + "static/award2-d5a8c470215a5875a8803998f8c355ad.jpg";